export default "__VITE_ASSET__YWAY3BOK__"